import React, { useState } from 'react'
import Modal from 'react-overlays/Modal'
import Dropdown from 'react-dropdown'
import 'react-dropdown/style.css'
import { toast } from 'react-toastify'
import { callAPI } from '../hooks/api'
import { LockToolTipIcon } from './upgrade-lock-icon-layout'
import useAbility from '@/hooks/use-ability'

export default function FeedbackPopupModal({
  setFeedbackPopupModal,
  feedbackPopupModal,
  property,
  setLoading,
}) {
  const [feedbackType, setFeedbackType] = useState(null)
  const [feedbackText, setFeedbackText] = useState('')

  const { checkAbility } = useAbility()

  const enableApnDisplay = checkAbility('apn_display')

  const handleClose = () => {
    setFeedbackPopupModal(false)
  }

  const handleSubmit = () => {
    if (feedbackType === null) {
      toast.warn('Please select your feedback type.')
      return
    }
    if (feedbackText === '') {
      toast.warn('Please fill out your feedback before submitting.')
      return
    }
    const feedback = {
      session_key: JSON.parse(localStorage.auth).sessionKey,
      apn: property.data.apn,
      county: property.data.county,
      feedback_type: feedbackType,
      feedback: feedbackText,
    }
    const endpoint = '/user_feedback'
    setLoading(true)
    callAPI(endpoint, feedback).then((res) => {
      setLoading(false)
      if (res.status === 'success') {
        toast.success('Successfully submitted feedback.')
      } else {
        toast.warn(res.msg)
      }
      handleClose()
    })
  }

  const renderBackdrop = (props) => <div className="backdrop" {...props} />

  const feedbackOptions = [
    'Incorrect Information',
    'Missing Information',
    'Other',
  ]

  return (
    <>
      <div
        className="bg-black bg-opacity-50 flex items-center justify-center fixed left-0 right-0 bottom-0 top-0 z-[200]"
        onClick={(e) => e.stopPropagation()}
      ></div>
      <div>
        <Modal
          className="modal"
          show={feedbackPopupModal}
          onHide={handleClose}
          renderBackdrop={renderBackdrop}
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '90%',
            maxWidth: '500px',
            height: 'auto',
            maxHeight: '90%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1500,
            backgroundColor: 'white',
            borderRadius: '8px',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
            padding: '20px',
            overflowY: 'auto',
          }}
        >
          <div style={{ width: '100%' }}>
            <div
              className="modal-header"
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                marginBottom: '20px',
              }}
            >
              <div
                className="modal-title"
                style={{ fontSize: '20px', fontWeight: 'bold' }}
              >
                Send us Feedback
              </div>
              <div>
                <span
                  className="close-button"
                  style={{ cursor: 'pointer' }}
                  onClick={handleClose}
                >
                  x
                </span>
              </div>
            </div>
            <div
              className="modal-body"
              style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}
            >
              <div
                className="input-group"
                style={{ display: 'flex', flexDirection: 'column' }}
              >
                <div
                  style={{
                    marginBottom: '5px',
                    fontWeight: 'bold',
                    display: 'flex',
                    gap: '4px',
                  }}
                >
                  APN:
                  <LockToolTipIcon show={!enableApnDisplay} />
                </div>
                {enableApnDisplay && (
                  <div
                    style={{
                      padding: '10px',
                      border: '1px solid #ccc',
                      borderRadius: '4px',
                    }}
                  >
                    {property.data.apn}
                  </div>
                )}
              </div>
              <div
                className="input-group"
                style={{ display: 'flex', flexDirection: 'column' }}
              >
                <label style={{ marginBottom: '5px', fontWeight: 'bold' }}>
                  Feedback Type:
                </label>
                <Dropdown
                  options={feedbackOptions}
                  onChange={(option) => setFeedbackType(option.value)}
                  placeholder="Select an option"
                  className="dropdown"
                  controlClassName="dropdown-control"
                  placeholderClassName="dropdown-placeholder"
                  menuClassName="dropdown-menu"
                />
              </div>
              <div
                className="input-group"
                style={{ display: 'flex', flexDirection: 'column' }}
              >
                <label style={{ marginBottom: '5px', fontWeight: 'bold' }}>
                  Feedback:
                </label>
                <textarea
                  value={feedbackText}
                  onChange={(e) => setFeedbackText(e.target.value)}
                  placeholder="Write your feedback here"
                  style={{
                    padding: '10px',
                    border: '1px solid #ccc',
                    borderRadius: '4px',
                    minHeight: '80px',
                  }}
                />
              </div>
            </div>
            <div
              className="modal-footer"
              style={{
                marginTop: '20px',
                display: 'flex',
                justifyContent: 'flex-end',
              }}
            >
              <button
                onClick={handleSubmit}
                style={{
                  padding: '10px 20px',
                  backgroundColor: '#007bff',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer',
                }}
              >
                Submit
              </button>
            </div>
          </div>
        </Modal>
      </div>
    </>
  )
}
